import { render, staticRenderFns } from "./PatientAgreeDetail.vue?vue&type=template&id=b87d6936&scoped=true&"
import script from "./PatientAgreeDetail.vue?vue&type=script&lang=js&"
export * from "./PatientAgreeDetail.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/page/patientAgreeDetail.css?vue&type=style&index=0&id=b87d6936&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87d6936",
  null
  
)

export default component.exports